import DefaultLayout from '../../../layout/DefaultLayout';
import SectionWrapper from '../../../components/SectionWrapper/SectionWrapper';
import SaleCancelPanel from '../../../components/Sales/cancel/SaleCancelPanel';
import BreadcrumbTwo from '../../../components/Breadcrumbs/BreadcrumbTwo';

const SaleCancel = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <SectionWrapper>
        <SaleCancelPanel />
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default SaleCancel;
